import React, { useEffect, useRef } from 'react'
import { connect } from 'react-redux';
import { isDirty, submit } from 'redux-form';
import * as $ from 'jquery';
import Alert from '../../../../itrust_common/components/Alert';
import { useHistory } from 'react-router-dom';
import ClaimFormDownload from './ClaimFormDownload';
import ClaimFormSync from './ClaimFormSync';
import DateFormatView from '../../../../itrust_common/components/others/DateFormatView';
import RpaClaimSubmitButton from '../../../../containers/authorised/addOns/rpa/vision_insurance/claimForm/submitClaim/RpaClaimSubmitButton';
import { claimFormDestroy } from '../../../../redux/actions/order/claimFormActions';
import ClaimFormClaimType from './ClaimFormClaimType';

function ClaimFormHeader(props) {
  const {
    dispatch,
    order,
    trizettoSending,
    ediClearingHouseConfig,
    onTrizettoSend,
    userRole,
    visionInsuranceConfig,
    selectedOrderInsurance,
    claimFormId,
    inModal,
    onDelete,
    isClaimFormDirty,
  } = props
  const history = useHistory()
  const saveTooltipRef = useRef(null)
  const orderInsurance = order.orders_insurances_attributes?.find(
    (item) => item.id === selectedOrderInsurance?.id,
  ) || selectedOrderInsurance
  const sendToLabel = orderInsurance?.patient_insurance_attributes?.insurance_name
  const claimSubmissionAt = orderInsurance?.claim_submission_at || order.claim_submission_at

  useEffect(() => {
    const $el = $(saveTooltipRef.current)
    if (!isClaimFormDirty) {
      $el.tooltip({ placement: 'top', trigger: 'hover' })
    } else {
      $el.tooltip('dispose')
    }
    return () => {
      $el.tooltip('dispose')
    }
  }, [isClaimFormDirty])

  const handleSendToTrizetto = () => {
    if (ediClearingHouseConfig.visible && (ediClearingHouseConfig.status === 'inactive' || ediClearingHouseConfig.status === 'in_progress')) {
      history.push(`/add-ons/edi-clearing-house/${['super_admin', 'itrust_admin'].includes(userRole) ? 'settings' : 'graph-report'}`)
      $('#orderForm-modal').modal('hide');
    }
    else if (isClaimFormDirty) {
      dispatch(submit("1500ClamForm"))
      setTimeout(() => {
        let invalidInputs = (document.getElementsByClassName("is-invalid")?.length || document.getElementsByClassName("invalid-feedback")?.length)
        if (invalidInputs) {
          Alert.warning("Please fill the required information.")
        } else {
          onTrizettoSend()
        }
      }, 500)
    } else {
      onTrizettoSend()
    }
  }

  const handleDelete = () => {
    if (!claimFormId) return

    Alert.confirm('Are you sure you want to delete this claim form?', async (res) => {
      if (!res) return

      // Close first so destroy/reset does not reload the deleted claim form id
      onDelete && onDelete()
      await dispatch(claimFormDestroy(order.id, claimFormId))
    })
  }

  const actionButtonClass = inModal
    ? 'btn btn-outline-primary text-nowrap my-0'
    : 'btn btn-outline-primary my-lg-0 my-md-2 ml-md-5'

  return (
    <div className={`clam-form-actions-wrap w-100 ${inModal ? 'px-7 py-4' : 'bg-light px-md-7 px-lg-0 pb-6'}`}>
      <div className="d-flex flex-row justify-content-between align-items-center mx-auto">
        <div>
          {!orderInsurance?.visionary_insurance_claim_form_id && <>
            <button className={`${actionButtonClass} ${!inModal && 'mr-lg-7 mr-md-5 mx-md-4 my-md-2 mx-lg-0 my-lg-0'}`} onClick={handleSendToTrizetto}>
              {trizettoSending ? 'Sending...' : sendToLabel ? `Send to ${sendToLabel}` : (ediClearingHouseConfig.visible ? 'Send to iTRUST EDI Clearinghouse' : 'Send to Trizetto')}
            </button>
          </>}
          {visionInsuranceConfig?.visible && orderInsurance?.visionary_insurance_claim_form_id && (
            <RpaClaimSubmitButton order={order} selectedOrderInsurance={orderInsurance} />
          )}
          {claimSubmissionAt && <span>Previous Claim Send on <DateFormatView dateTime={claimSubmissionAt} /></span>}
        </div>
        <div className={`d-flex align-items-end ${inModal ? 'flex-wrap' : 'align-items-center'}`}>
          {inModal && (
            <ClaimFormClaimType inline selectedOrderInsurance={selectedOrderInsurance} />
          )}
          <ClaimFormDownload inModal={inModal} />
          {claimFormId && (
            <>
              <ClaimFormSync label="Sync Data" inModal={inModal} selectedOrderInsurance={selectedOrderInsurance} />
              <button type="button" className={`btn btn-outline-danger text-nowrap ${inModal ? 'my-0 ml-md-3' : 'my-lg-0 my-md-2 ml-md-5'}`} onClick={handleDelete}>
                <i className="la la-trash mr-2" />
                Delete
              </button>
            </>
          )}
          <span
            ref={saveTooltipRef}
            className={`${inModal ? 'ml-md-3' : 'ml-md-5'} d-inline-block`}
            data-toggle="tooltip"
            data-placement="top"
            title={!isClaimFormDirty ? 'Edit the form to enable Save' : ''}
          >
            <button
              type="button"
              disabled={!isClaimFormDirty}
              className={`btn btn-primary ${inModal ? 'text-nowrap my-0' : 'my-lg-0 my-md-2'}`}
              style={!isClaimFormDirty ? { pointerEvents: 'none' } : undefined}
              onClick={() => dispatch(submit("1500ClamForm"))}
            >
              Save
            </button>
          </span>
        </div>
      </div>
    </div>
  )
}

const mapStateToProps = (state) => {
  const { organisation: { organisation } } = state

  return {
    visionInsuranceConfig: organisation.add_ons_config?.type?.vision_insurance,
    isClaimFormDirty: isDirty('1500ClamForm')(state),
  }
}

export default connect(mapStateToProps)(ClaimFormHeader)
